import { GET_ARMOUR_TYPES_LOADING, GET_ARMOUR_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getArmourTypesSuccess = payload => {
    return ({
        type: GET_ARMOUR_TYPES_SUCCESS,
        payload
    })
}

export const getArmourTypesAsync = payload => dispatch => {
    return client.service('armour-types').find()
		.then((response) => {
            dispatch(getArmourTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}